import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

// 徹底的 ResizeObserver 錯誤修復方案
(function() {
  // 1. 保存原始的 ResizeObserver
  const OriginalResizeObserver = window.ResizeObserver;
  
  // 2. 創建安全的 ResizeObserver wrapper
  window.ResizeObserver = class SafeResizeObserver {
    constructor(callback) {
      this.callback = callback;
      this.observer = new OriginalResizeObserver((entries, observer) => {
        // 使用 requestIdleCallback 或 setTimeout 來避免同步執行
        const safeCallback = () => {
          try {
            this.callback(entries, observer);
          } catch (error) {
            // 完全忽略所有 ResizeObserver 相關錯誤
            if (error.message && error.message.includes('ResizeObserver')) {
              return; // 靜默忽略
            }
            // 其他錯誤繼續拋出
            throw error;
          }
        };
        
        if (window.requestIdleCallback) {
          window.requestIdleCallback(safeCallback, { timeout: 100 });
        } else {
          setTimeout(safeCallback, 0);
        }
      });
    }
    
    observe(target, options) {
      return this.observer.observe(target, options);
    }
    
    unobserve(target) {
      return this.observer.unobserve(target);
    }
    
    disconnect() {
      return this.observer.disconnect();
    }
  };

  // 3. 攔截所有可能的錯誤
  const errorStrings = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications'
  ];

  window.addEventListener('error', (event) => {
    if (errorStrings.some(str => event.message.includes(str))) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && errorStrings.some(str => String(event.reason).includes(str))) {
      event.preventDefault();
      return false;
    }
  });

  // 4. 覆蓋 console.error 來攔截控制台錯誤
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (errorStrings.some(str => message.includes(str))) {
      return; // 靜默忽略 ResizeObserver 錯誤
    }
    originalConsoleError.apply(console, args);
  };
})();

// 從 localStorage 載入認證資料
const accessToken = localStorage.getItem('accessToken');
if (accessToken) {
    store.commit('auth/setAccessToken', accessToken);
    store.commit('auth/setLogin', true);
}

createApp(App).use(store).use(router).use(Antd).mount('#app')
